<style scoped>
	.template{ padding: 10px; min-height: calc(100vh);}
	.uphoto{ width: 3rem;height: 3rem;border-radius: 50%;overflow: hidden;}
	.uphoto img{width: 100%;}
	.userInfo{display: flex;flex-direction: row;}
	.userIn{ padding: 8px;display: flex;flex-direction: column;justify-content: space-around;}
	.lx{ font-size: 0.8rem;}
	.udisc{ font-size: 0.8rem;}
	.anliList{ width: 100%;display: flex;flex-direction: row;flex-wrap: wrap;}
	.anliListItem{ width: 50%;padding: 0.3rem;box-sizing: border-box;background-color: #f2f2f2;}

</style>
<template>
	<div class="template" v-if="user!={}">
		<div class="userInfo">
			<div class="uphoto">
				<img :src="user?user.headimg?imgAPI + user.headimg:require('../../../../public/icon/001.jpg'):require('../../../../public/icon/001.jpg')" @click="" />
			</div>
			<div class="userIn">
				<div class="uname">{{user?user.name:user.name}}</div>
				<div class="lx"> 联系方式: {{user.phone?user.phone:'暂无'}} </div>
			</div>
		</div>
		<div class="udisc">
			<p v-if="user.introduce_myself=='' && user.introduce_myself==null ">暂无介绍</p>
			<p v-else>{{user.introduce_myself?user.introduce_myself:user.introduce}}</p>
		</div>

		<div class="anliList">
			<div class="anliListItem" v-for="ai,index in anliArr" @click="seePhoto(ai)">
				<img :src="imgAPI+ai.imgUrlArr[0]" style="width: 100%;" />
			</div>
		</div>
		
		<el-dialog title="" :show-close="false" :visible.sync="seePhotoDlog" class="myDlog myDlog_opa" :fullscreen="true">
			<worksInfoDlog :pageParams="pageParams" v-on:parentMethod="communication" v-if="seePhotoDlog"></worksInfoDlog>
		</el-dialog>
	</div>
</template>

<script>
	import baseConst from '../../../assets/js/baseConst.js' //注意路
	const worksInfoDlog = () =>
		import("@/components/mobile/two/anliInfo.vue"); //作品详情
	export default {
		components: {
			worksInfoDlog
		},
		data() {
			return {
				user: {},
				imgAPI: '',
				anliArr: [],
				seePhotoDlog:false,
			}
		},
		created: function() {
			let _this = this;
			_this.imgAPI = baseConst.IMG_API;
			_this.user = JSON.parse(_this.$route.query.user);
			_this.getDesignLise();
		},
		mounted: function() {
			let _this = this;
		},
		methods: {
			/*获取设计案例
			 创建于2019-11-25  作者：郑凯*/
			getDesignLise() {
				let _this = this;
				let params = {
					limit: 20000,
					pageNumber: 1,
					design_org_id: _this.user.design_org_id
				};
				_this.getApi('/api/getDesignOrgWorks', params)
					.then((res) => {
						if(res.status == '00') {
							_this.pageNumber = res.data.pageNumber;
							_this.anliArr = res.data.data;
							for(let i = 0; i < _this.anliArr.length; i++) {
								let imgUrlArr = [];
								imgUrlArr = _this.anliArr[i].works.split('|');
								_this.anliArr[i].imgUrlArr = imgUrlArr;
							}
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/**  * -----查看图片
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			seePhoto(obj) {
				let _this = this;
				_this.pageParams = JSON.parse(JSON.stringify(obj));
				_this.seePhotoDlog = true;
			},
			/**  * -----这个组件的子组件通信处理    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			communication(type) {
				let _this = this;
				switch(type) {
					case 'works_info':
						_this.seePhotoDlog = false;
						break;
					default:
				}
			},
		}
	}
</script>